module.exports = __webpack_public_path__ + "7e398632a5e184a25f52b79e3c7d5ace.pdf";